export class GroupClass {
    public _id: string;
    public name: string;
    public classTemplate: any;
    public gym: any;
    public date: Date;
    public participants: any[];

    constructor() {}
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/models/groupClass.ts